<template>
  <div class="transaction-data">
    <div class="data-panel">
      <div class="top">
        <div class="title">交易数据</div>
        <van-dropdown-menu v-if="showSelect" active-color="#ecc381">
          <van-dropdown-item
            v-model="selected"
            :options="options"
            @change="onSelect"
          ></van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <circular-graph
        :graphData="graphData"
        :isNoData="isNoData"
      ></circular-graph>
      <div class="bottom">
        <div class="total" v-if="showAllMoney">
          <span>累计总交易金额（元）</span>
          <span class="num">{{ allMoney || 0 | formatMoney }}</span>
        </div>
        <div class="thirty-detail" v-if="thirtyDayFlag" @click="goThirtyDetail">
          激活后30天内交易明细
          <span class="arrow">>></span>
        </div>
      </div>
    </div>
    <div class="data-list">
      <div class="item" v-for="(item, index) in currList" :key="index">
        <div class="left">
          <div>{{ item.remark || item.name }}（元）</div>
          <div>{{ item.allSum || item.tradeAmt || 0 | formatMoney }}</div>
        </div>
        <!-- <div class="right">
          <div>{{ item.remark || item.name }}（笔）</div>
          <div>{{ item.allCount || item.tradeCount || 0 }}</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import circularGraph from '@/views/components/circular-graph.vue'
import { formatMoney } from '@/utils/utils'
export default {
  components: { circularGraph },
  filters: {
    formatMoney
  },
  props: {
    buTypeList: {
      type: Array,
      default() {
        return []
      }
    },
    tradeObj: {
      type: Object,
      default() {
        return {}
      }
    },
    showSelect: {
      type: Boolean,
      default() {
        return true
      }
    },
    tradeList: {
      type: Array,
      default() {
        return []
      }
    },
    thirtyDayFlag: {
      type: Number,
      default() {
        return 0
      }
    },
    allMoney: {
      type: Number,
      default() {
        return 0
      }
    },
    showAllMoney: {
      type: Boolean,
      default() {
        return true
      }
    },
    businessId: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      selected: 0,
      options: [],
      currList: [], // 当前选中列表
      graphData: [], // 图表数据
      isNoData: true // 图表数据是否全部有数据 ps：不全为0
    }
  },
  watch: {
    buTypeList() {
      this.init()
    },
    tradeList() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.currList = []
      if (this.showSelect) {
        this.selected = 0
        this.options = [
          {
            text: '全部',
            value: 0
          }
        ]
        for (let item of this.buTypeList) {
          this.options.push({
            text: item.typesDesc,
            value: item.types
          })
        }
        this.currList = this.tradeObj[this.selected] || []
        this.formatGraph()
      } else {
        this.currList = JSON.parse(JSON.stringify(this.tradeList))
        this.isNoData = true
        this.graphData = []
        let countObj = {
          name: '总交易',
          tradeAmt: 0,
          tradeCount: 0
        } // 总交易量、金额
        for (let item of this.currList) {
          if (item.name === '总交易') {
            continue
          }
          this.graphData.push({
            value: item.tradeAmt || '',
            name: item.name
          })
          countObj.tradeAmt += item.tradeAmt
          countObj.tradeCount += item.tradeCount
          if (item.tradeAmt) {
            this.isNoData = false
          }
        }
        this.currList.push(countObj)
      }
    },
    onSelect(e) {
      this.selected = e
      this.currList = this.tradeObj[this.selected] || []
      this.formatGraph()
    },
    formatGraph() {
      this.isNoData = true
      this.graphData = []
      let countObj = {
        remark: '总交易',
        allCount: 0,
        allSum: 0
      }
      let flag = 0
      for (let item of this.currList) {
        if (item.remark === '总交易') {
          flag = 1
          continue
        }
        this.graphData.push({
          value: item.allSum || '',
          name: item.remark
        })
        countObj.allCount += item.allCount
        countObj.allSum += item.allSum
        if (item.allSum) {
          this.isNoData = false
        }
      }
      if (!flag) {
        this.currList.push(countObj)
      }
    },
    goThirtyDetail() {
      this.$router.push({
        path: '/thirty-details',
        query: {
          businessId: this.businessId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.transaction-data {
  margin-top: 10px;
  .data-panel {
    background: #fff;
    .top {
      height: 55px;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px 0;
    }
    .bottom {
      padding: 15px;
      border-top: 1px solid #f2f2f2;
      font-size: 13px;
      color: #333333;
      line-height: 1;
      .total {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .thirty-detail {
        width: 100%;
        text-align: right;
        padding-top: 15px;
        color: #999;
        .arrow {
          color: #ecc381;
        }
      }
      .num {
        font-size: 16px;
        color: #ecc381;
      }
    }
  }
  .data-list {
    margin-top: 10px;
    background: #fff;
    .item {
      height: 75px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f2f2f2;
      .left {
        text-align: left;
      }
      .right {
        text-align: right;
      }
      > div {
        line-height: 1;
        :first-child {
          font-size: 12px;
          color: #999;
        }
        :last-child {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          padding-top: 9px;
        }
      }
    }
  }
  /deep/.van-dropdown-menu__bar {
    border: 1px solid #ccc;
    border-radius: 5px;
    min-width: 54px;
    width: auto;
    height: 25px;
    box-shadow: none;
    color: #999;
    font-size: 13px;
    display: inline-block;
    padding-right: 10px;
  }
  /deep/.van-dropdown-menu__item {
    height: 25px;
  }
  /deep/.van-ellipsis {
    color: #999;
    font-size: 13px;
  }
  /deep/.van-dropdown-menu__title::after {
    // display: none;
  }
}
</style>
